export function getNowDateWithString(){
  var dt = new Date();
  var y = dt.getFullYear();
  var m = ("00" + (dt.getMonth()+1)).slice(-2);
  var d = ("00" + dt.getDate()).slice(-2);
  var result = y + "/" + m + "/" + d;
  return result;
}

export function getPastDateWithString(days){
  var dt = new Date();
  dt.setDate(dt.getDate() - days)

  var y = dt.getFullYear();
  var m = ("00" + (dt.getMonth()+1)).slice(-2);
  var d = ("00" + dt.getDate()).slice(-2);
  var result = y + "/" + m + "/" + d;
  return result;
}

export function convertToDate(dateString){
  let converted = dateString.slice(0, 10);
  return converted.replace(/-/g, "/");
}

const hasChildren = item => {
  return item.children.length > 0
}

export function flattenNestedList(list){
  const flattenedList = []
  const expandChildren = list => {
    list.forEach(item=>{
      flattenedList.push({
        id: item.id,
        text: item.name
      })
      hasChildren(item) && expandChildren(item.children)
    })
  }

  expandChildren(list)
  return flattenedList
}

export function getTreesByIds(ids, trees){
  const targetTrees = []
  const expandChildren = trees => {
    trees.forEach(item=>{
      if(ids === null){
        targetTrees.push(item)
      }else if(ids.includes(item.id)){
        targetTrees.push(item)
      }else{
        hasChildren(item) && expandChildren(item.children)
      }
    })
  }
  expandChildren(trees)
  return targetTrees
}

export function flattenShopsInNestedList(list){
  const flattenedShops = []
  const idSet = new Set()
  const expandChildren = list => {
    list.forEach(item=>{
      item.shops.forEach(shop=>{
        if(!idSet.has(shop.id)){
          flattenedShops.push({
            id: shop.id,
            name: shop.name,
            text: shop.name
          })
        }
        idSet.add(shop.id)
      })
      hasChildren(item) && expandChildren(item.children)
    })
  }

  expandChildren(list)
  return flattenedShops
}
